<template>
  <b-card
    :id="getTableId"
    :class="{'initial-flex': getCollapse, 'table-scroll': items.length > 10}"
    no-body
  >
    <template slot="header">
      <div
        class="header-toggle"
        @click="toggle()"
      >
        <b>{{ getTitle }}</b>
        <font-awesome-icon
          v-if="getCollapse"
          class="float-right"
          :icon="['fas','chevron-down']"
        />
        <font-awesome-icon
          v-else
          class="float-right "
          :icon="['fas','chevron-up']"
        />
      </div>
    </template>
    <b-collapse
      :id="getCollapseId"
      visible
    >
      <complex-table-view
        :small="true"
        :is-batch="true"
        :items="items"
        :fields="fields"
        :total-rows="items.length"
        :options="options"
        :field-row-colors="fieldRowColors"
        :batch-upload-fields-length="batchUploadFieldsLength"
        :modal-name="modalName"
        selected="all"
        @row-clicked="rowClicked"
        @sort-changed="onSortChanged"
        @context-change="contextChanged"
        @per-page-change="onPerPageChange"
        @filter="filterData"
        @current-page-change="onCurrentPageChange"
      />
    </b-collapse>
  </b-card>
</template>

<script>
import ComplexTableView from '../../../../core/components/complex-table/components/ComplexTableView';
import {createNamespacedHelpers} from 'vuex';

const {mapActions} = createNamespacedHelpers('monitoring');

export default {
  name: 'BatchUploadTable',
  components: {ComplexTableView},
  props: {
    items: Array,
    collapse: Object,
    fields: Array,
    isBatchUpload: {
      type: Boolean,
      default: false,
    },
    options: Array,
    fieldRowColors: {
      type: Array,
      default: () => [],
    },
    batchUploadFieldsLength: Number,
    modalName: {
      type: String,
      required: true,
    },
  },
  computed: {
    getCollapse() {
      if (this.isBatchUpload) {
        return !this.collapse.batchUpload;
      }
      return !this.collapse.batchFileUpload;
    },
    getTitle() {
      if (this.isBatchUpload) {
        return 'Batch Upload Table';
      }
      return 'Batch File Upload Table';
    },
    getCollapseId() {
      if (this.isBatchUpload) {
        return 'batch-upload-collapse';
      }
      return 'batch-file-upload-collapse';
    },
    getTableId() {
      if (this.isBatchUpload) {
        return 'batch-upload';
      }
      return 'batch-file-upload';
    },
  },
  methods: {
    ...mapActions(['changePaginationData']),
    rowClicked(e) {
      this.$emit('row-clicked', e);
      if (!e.BatchFileUploadId) {
        this.toggle();
      }
    },
    filterData(e) {
      this.$emit('filter', e);
    },
    toggle() {
      if (this.isBatchUpload) {
        this.collapse.batchUpload = !this.collapse.batchUpload;
        this.$root.$emit('bv::toggle::collapse', 'batch-upload-table-collapse');
      } else {
        this.collapse.batchFileUpload = !this.collapse.batchFileUpload;
        this.$root.$emit('bv::toggle::collapse', 'batch-file-upload-table-collapse');
      }
    },
    onSortChanged(event) {
      this.items.sort(function (a, b) {
        if (a[event.sortBy] < b[event.sortBy]) {
          return event.sortDesc ? 1 : -1;
        }
        if (a[event.sortBy] > b[event.sortBy]) {
          return event.sortDesc ? -1 : 1;
        }
        return 0;
      });
    },
    onPerPageChange() {
      // console.log('onPerPageChange ', arguments);
    },
    onCurrentPageChange() {
      // console.log('onCurrentPageChange ', arguments);
    },
    contextChanged(context) {
      this.changePaginationData({perPage: context.pagination.perPage, currentPage: context.pagination.page});
    },
  },
};
</script>

<style scoped lang="scss">

.table-scroll {
  overflow: auto;
}
</style>